export enum ResultSetDropdownId {
  SUMMARY_INPUTS_CAT = 'summary-inputs-cat',
  SUMMARY_INPUTS_CURR = 'summary-inputs-curr',
  SUMMARY_INPUTS_UNIT_TYPE = 'summary-inputs-unit-type',
  SUMMARY_OUTPUTS_PERIOD = 'summary-outputs-period',
  PFD_PERIOD = 'pfd-period',
  PFD_UNIT_TYPE = 'pfd-unit-type',
  DETAILED_SUMMARY_CAT = 'detailed-summary-cat',
  DETAILED_SUMMARY_SELECTED_RES = 'detailes-summary-selected-res',
  DETAILED_SUMMARY_CURR = 'detailed-summary-curr',
  DETAILED_SUMMARY_UNIT_TYPE = 'detailed-summary-unit-type',
  DETAILED_SUMMARY_PERIOD = 'detailed-summary-period',
  TECHNICAL_SELECTED_RESULTS = 'tech-selected-res',
  TECH_PERIOD_TYPE = 'tech-period-type',
  TECH_UNIT_TYPE = 'tech-unit-type',
  INCOME_STATEMENT_CAT = 'income-statement-cat',
  INCOME_STATEMENT_CURR = 'income-statement-curr',
  FINANCIAL_METRICS_RES = 'financial-metrics-res',
  FINANCIAL_METRICS_CURR = 'financial-metrics-curr'
}
